module.exports = __webpack_public_path__ + "img/device_pic_standby.82c83d35.svg";